export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function boolifyPromise(promise) {
  return promise.then(() => true).catch(() => false);
}
